import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39d76349&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=39d76349&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d76349",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/index.vue
// module id = 2290
// module chunks = 31